import React from 'react'
import { Icon } from './FontIcon.styles'
const FontIcon = ({
  size = undefined,
  color = undefined,
  colorDesktop = undefined,
  iconName = undefined,
  ...rest
}) => (
  <Icon
    size={size}
    colorDesktop={colorDesktop}
    color={color}
    className={`icon-${iconName}`}
    {...rest}
  />
)
export default FontIcon
